import { formatMoscowDateTime, formatRate } from '@/helpers/rates'
import type { MarketRates } from '@/hooks/useMarketRates'
import { SectionCard } from './SectionCard'

type MarketRatesCardProps = {
  rates: MarketRates
  isLoading: boolean
  errorMessage: string | null
  onRefresh: () => void
}

export const MarketRatesCard = ({
  rates,
  isLoading,
  errorMessage,
  onRefresh,
}: MarketRatesCardProps) => (
  <SectionCard
    title="Биржевые курсы"
    footer={
      <button
        type="button"
        onClick={onRefresh}
        disabled={isLoading}
        className="text-sm font-medium text-[var(--app-accent)] transition hover:opacity-80 disabled:opacity-50"
      >
        {isLoading ? 'Обновление...' : 'Обновить'}
      </button>
    }
  >
    <div className="grid grid-cols-2 gap-3">
      <div className="rounded-[18px] bg-[var(--app-input)] px-4 py-3">
        <p className="text-xs text-[var(--app-muted)]">ЦБ</p>
        <p className="mt-1 text-lg font-semibold text-[var(--app-text)]">
          {formatRate(rates.cbr?.rate)}
        </p>
        <p className="mt-1 text-xs text-[var(--app-muted)]">
          {formatMoscowDateTime(rates.cbr?.updatedAt)}
        </p>
      </div>
      <div className="rounded-[18px] bg-[var(--app-input)] px-4 py-3">
        <p className="text-xs text-[var(--app-muted)]">Forex</p>
        <p className="mt-1 text-lg font-semibold text-[var(--app-text)]">
          {formatRate(rates.forex?.ask)}
        </p>
        <p className="mt-1 text-xs text-[var(--app-muted)]">
          {formatMoscowDateTime(rates.forex?.updatedAt)}
        </p>
      </div>
      <div className="col-span-2 rounded-[18px] bg-[var(--app-input)] px-4 py-3">
        <p className="text-xs text-[var(--app-muted)]">Поставщик</p>
        <div className="mt-2 grid grid-cols-3 gap-2">
          <RateValue label="TOD-TOD" value={rates.supplier?.todTod} />
          <RateValue label="TOD-TOM" value={rates.supplier?.todTom} />
          <RateValue label="TOM-TOM" value={rates.supplier?.tomTom} />
        </div>
        <p className="mt-2 text-xs text-[var(--app-muted)]">
          {formatMoscowDateTime(rates.supplier?.updatedAt)}
        </p>
      </div>
    </div>
    {errorMessage && (
      <p className="mt-3 text-sm text-[var(--app-muted)]">{errorMessage}</p>
    )}
  </SectionCard>
)

type RateValueProps = {
  label: string
  value: number | undefined
}

const RateValue = ({ label, value }: RateValueProps) => (
  <div className="min-w-0">
    <p className="text-xs text-[var(--app-muted)]">{label}</p>
    <p className="mt-1 truncate text-sm font-semibold text-[var(--app-text)]">
      {formatRate(value)}
    </p>
  </div>
)
